import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useTranslation } from 'react-i18next';
import './Calendar.css';

const Calendar = ({ events = [], onEventClick, onDateClick, editable = false, headerToolbar }) => {
  const { t } = useTranslation();

  const defaultHeaderToolbar = {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay',
    ...headerToolbar
  };

  return (
    <div className="calendar-container">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={defaultHeaderToolbar}
        events={events}
        eventClick={onEventClick}
        dateClick={onDateClick}
        editable={editable}
        selectable={editable}
        selectMirror={true}
        dayMaxEvents={true}
        locale="nl"
        firstDay={1}
        buttonText={{
          today: t('calendar.today'),
          month: t('calendar.month'),
          week: t('calendar.week'),
          day: t('calendar.day'),
          prev: '❮',
          next: '❯'
        }}
        eventTimeFormat={{
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        }}
      />
    </div>
  );
};

export default Calendar;
